import { createStore } from "solid-js/store"
import { DevicePreference, persisted } from "@/storage/persist"

/**
 * Device preference: the tunnel provider the user pinned for each machine in
 * this browser. A machine without a pin uses the fastest measured route.
 */
export function createRoutePinPreference() {
  const [store, setStore] = persisted(
    DevicePreference.global("machine-route-pins"),
    createStore<{ pins: Record<string, string | undefined> }>({ pins: {} }),
  )
  return {
    pinned: (machine: string) => store.pins[machine],
    pin: (machine: string, provider: string | undefined) => setStore("pins", machine, provider),
    /** Prune only against a successfully loaded authoritative fleet snapshot. */
    retain: (machines: readonly string[]) => {
      const names = new Set(machines)
      for (const name of Object.keys(store.pins)) {
        if (!names.has(name)) setStore("pins", name, undefined)
      }
    },
  }
}
